import moment from "moment";

export default function toLocalUpdateTime(date) {
  return moment(date).format("YYYY-MM-DDTHH:mm:ss.SSS");
}
